<template>
  <div v-if="loaded" id="app">
    <div v-if="chrome" class="">
      <header class="navbar navbar-expand-md navbar-dark d-print-none">
        <div class="container-xl">
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbar-menu">
            <span class="navbar-toggler-icon"></span>
          </button>
          <h1 class="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
            <router-link to="/">
              <svg viewBox="0 0 417.64 57.48" preserveAspectRatio="xMidYMid meet" class="logo">
                <path
                  d="M270.14 316.07h14.76l12 19.51 12-19.51h14.76v50.4h-13.84v-28.94l-12.89 19.73h-.29l-12.82-19.59v28.8h-13.68zM328.57 354.53l-.06-.13c-4.81-10.31-1.24-21.91 9.2-26.77 12.2-5.69 22 .63 26.82 11 .36.79.79 1.7 1.12 2.58l-23.62 11c2.77 3.4 6.49 4 10.34 2.25 2.94-1.37 4.77-3.57 6.16-7.24l9.5 2.48c-1.39 5.89-4.94 11-12 14.33-11.03 5.18-22.35 1.46-27.46-9.5zm22.58-14.27c-2.28-3.7-5.72-5.11-9.11-3.53s-4.3 5.1-3.16 9.25zM369.75 347.17V347c0-12.67 7.92-20.38 17.13-20.38a14.9 14.9 0 0112 5.62v-18.33h13.68v52.56h-13.72v-5.18c-2.67 3.24-6 6-11.88 6-9.22.05-17.21-7.66-17.21-20.12zm29.3-.14v-.14c0-5.12-3.52-8.79-7.92-8.79s-8 3.6-8 8.79v.11c0 5.19 3.6 8.86 8 8.86s7.92-3.64 7.92-8.86zM415.31 315.85c0-3.38 2.77-6 7-6s7 2.44 7 5.82c0 3.57-2.78 6.18-7 6.18s-7-2.61-7-6zm.16 11.61h13.68v39h-13.68zM474.66 327.46v38.76H461V361c-2.66 3.24-6 6-11.88 6-9.21 0-17.21-7.71-17.21-20.17v-.14c0-12.67 7.92-20.38 17.14-20.38A14.88 14.88 0 01461 332v-4.5m.24 19.53v-.14c0-5.12-3.53-8.79-7.92-8.79s-8 3.6-8 8.79v.11c0 5.19 3.6 8.86 8 8.86s7.89-3.64 7.89-8.86zM477.22 316.07h25.85c6.34 0 10.8 1.58 13.75 4.53a11 11 0 013.24 8.14v.15c0 5.83-3.31 9.28-7.77 11.23 6.12 2 10 5.47 10 12.31v.15c0 8.64-7.06 13.89-19.08 13.89h-26zm22.4 20.09c4.24 0 6.62-1.44 6.62-4.4v-.14c0-2.73-2.16-4.32-6.34-4.32h-9.07v8.86zm2 19.08c4.25 0 6.7-1.66 6.7-4.61v-.14c0-2.74-2.16-4.54-6.84-4.54h-10.65v9.29zM523.77 327.52h13.68v7.85c2.23-5.33 5.83-8.79 12.31-8.5v14.4h-1.15c-7.13 0-11.16 4.1-11.16 13.11v12.09h-13.68zM594.13 327.5v39h-13.68v-5.18c-2.67 3.24-6.05 6-11.88 6-9.22 0-17.21-7.71-17.21-20.17V347c0-12.67 7.92-20.38 17.14-20.38a14.89 14.89 0 0112 5.62v-4.74m.21 19.53v-.14c0-5.12-3.52-8.79-7.92-8.79s-8 3.6-8 8.79v.11c0 5.19 3.6 8.86 8 8.86s7.87-3.64 7.87-8.86zM596.92 315.85c0-3.38 2.77-6 7-6s7 2.44 7 5.82c0 3.57-2.78 6.18-7 6.18s-7-2.61-7-6zm.16 11.61h13.68v39h-13.68zM613.68 327.52h13.68V333c2.52-3.24 6.12-6.34 11.67-6.34 8.28 0 13.24 5.48 13.24 14.33v25.49h-13.68v-21.1c0-4.24-2.23-6.55-5.47-6.55s-5.76 2.31-5.76 6.55v21.1h-13.68zM653.44 361.58l5.11-8.28a25.31 25.31 0 0013.39 4.46c2.38 0 3.46-.72 3.46-2.09v-.14c0-1.52-2.16-2.16-6.27-3.31-7.7-2-13.82-4.61-13.82-12.46v-.15c0-8.28 6.62-12.89 15.63-12.89a30.46 30.46 0 0116 4.54l-4.68 8.64c-4-2.23-8.42-3.6-11.52-3.6-2.09 0-3.17.79-3.17 1.87v.15c0 1.51 2.24 2.23 6.34 3.45 7.7 2.16 13.83 4.83 13.83 12.39v.14c0 8.57-6.41 13-15.92 13a31.47 31.47 0 01-18.38-5.72z"
                  class="mediabrains-1" transform="translate(-270.14 -309.85)"></path>
              </svg>
            </router-link>
          </h1>
          <div class="navbar-nav flex-row order-md-last" v-if="$auth.isAuthenticated && $auth.user">
            <active-company></active-company>
            <div class="nav-item dropdown">
              <dropdown>
                <template v-slot:dropdown-toggle>
                  <a @click.prevent="" href="#" class="nav-link d-flex lh-1 text-reset p-0" data-bs-toggle="dropdown"
                    aria-label="Open user menu">
                    <span class="avatar avatar-sm">{{ userLetters }}</span>
                    <div class="d-none d-xl-block ps-2">
                      <div>
                        {{ $auth.user.contact.firstName }}
                        {{ $auth.user.contact.lastName }}
                      </div>
                      <div class="mt-1 small text-muted">
                        {{ $auth.user.contact.title }}
                      </div>
                    </div>
                  </a>
                </template>
                <router-link class="dropdown-item" to="/account">
                  Account
                </router-link>
                <a href="#" class="dropdown-item" @click.prevent="logout">
                  Logout
                </a>
              </dropdown>
            </div>
          </div>
          <div class="navbar-nav flex-row order-md-last" v-else>
            <div class="nav-item">
              <a href="https://www.mediabrains.com/?utm_source=mac_header" target="_blank" class="navlink text-white">
                MediaBrains Home
              </a>
            </div>
          </div>
        </div>
      </header>
      <div class="navbar-expand-md" v-if="$auth.isAuthenticated && $auth.user">
        <div class="collapse navbar-collapse" id="navbar-menu">
          <div class="navbar navbar-light">
            <div class="container-xl">
              <ul class="navbar-nav">
                <li :class="{ 'nav-item': true, active: $route.path == '/' }">
                  <router-link to="/" class="nav-link">
                    <span class="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-home" width="24"
                        height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <polyline points="5 12 3 12 12 3 21 12 19 12"></polyline>
                        <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                        <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
                      </svg>
                    </span>
                    <span class="nav-link-title"> Dashboard</span>
                  </router-link>
                </li>
                <li class="nav-item dropdown">
                  <dropdown :label="'Company'">
                    <template v-slot:dropdown-icon>
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-building" width="24"
                        height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <line x1="3" y1="21" x2="21" y2="21"></line>
                        <line x1="9" y1="8" x2="10" y2="8"></line>
                        <line x1="9" y1="12" x2="10" y2="12"></line>
                        <line x1="9" y1="16" x2="10" y2="16"></line>
                        <line x1="14" y1="8" x2="15" y2="8"></line>
                        <line x1="14" y1="12" x2="15" y2="12"></line>
                        <line x1="14" y1="16" x2="15" y2="16"></line>
                        <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"></path>
                      </svg>
                    </template>
                    <router-link class="dropdown-item" to="/profile">
                      Profile
                    </router-link>
                    <a class="dropdown-item" href="/n/listings">
                      Category Listings
                    </a>
                    <router-link class="dropdown-item" to="/products">
                      Products
                    </router-link>
                    <router-link class="dropdown-item" to="/content">
                      Content
                    </router-link>
                    <router-link class="dropdown-item" to="/pressreleases">
                      Press Releases
                    </router-link>
                    <router-link class="dropdown-item" to="/company/qr-codes">
                      QR Codes
                    </router-link>
                    <router-link class="dropdown-item" to="/company/key-features">
                      Key Features
                    </router-link>
                  </dropdown>
                </li>
                <li :class="{
                  'nav-item': true,
                  active: $route.path.startsWith('/reputation'),
                }">
                  <router-link :to="`/reputation`" class="nav-link">
                    <span class="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-star" width="24"
                        height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path
                          d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z">
                        </path>
                      </svg>
                    </span>
                    <span class="nav-link-title"> Reputation </span>
                  </router-link>
                </li>
                <li class="nav-item">
                  <dropdown :label="'Leads'">
                    <template v-slot:dropdown-icon>
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-users" width="24"
                        height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                        <path d="M21 21v-2a4 4 0 0 0 -3 -3.85"></path>
                      </svg>
                    </template>
                    <a class="dropdown-item" href="/n/leads">
                      Directory Leads
                    </a>
                    <a class="dropdown-item" v-if="$auth.hasLeadOrders" href="/n/lead-orders">Lead Orders</a>
                    <hr class="dropdown-divider">
                    <h5 class="ps-2">Notification Settings</h5>
                    <a class="dropdown-item" href="/n/endpoints">
                      Delivery
                    </a>
                    <a class="dropdown-item" href="/n/notifications">
                      Notification History
                    </a>
                  </dropdown>
                </li>

                <li class="nav-item dropdown">
                  <dropdown :label="'Reports'">
                    <template v-slot:dropdown-icon>
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chart-bar" width="24"
                        height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <rect x="3" y="12" width="6" height="8" rx="1"></rect>
                        <rect x="9" y="8" width="6" height="12" rx="1"></rect>
                        <rect x="15" y="4" width="6" height="16" rx="1"></rect>
                        <line x1="4" y1="20" x2="18" y2="20"></line>
                      </svg>
                    </template>
                    <router-link class="dropdown-item" to="/reports/audience-report">
                      Audience Insights Report
                    </router-link>
                    <router-link class="dropdown-item" to="/reports/graphical-ad-report">
                      Graphical Ad Report
                    </router-link>
                    <router-link class="dropdown-item" to="/reports/performance-report">
                      Performance Report
                    </router-link>
                    <router-link class="dropdown-item" to="/reports/visitor-insight-report">
                      Visitor Insights Report
                    </router-link>
                  </dropdown>
                </li>

                <li :class="{ 'nav-item': true }" v-if="$auth.user && $auth.user.contact">
                  <a class="nav-link"
                    :href="`https://www.mediabrains.com/help/?ajs_uid=${$auth.user.contact.contactId}&ajs_event=Clicked%20Knowledgebase%20Link`"
                    target="_blank">
                    <span class="nav-link-icon d-md-none d-lg-inline-block">
                      <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-question-mark"
                        width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"></path>
                        <line x1="12" y1="19" x2="12" y2="19.01"></line>
                      </svg>
                    </span>
                    <span class="nav-link-title">Knowledge base</span>
                  </a>
                </li>
              </ul>

              <div class="d-flex align-items-center my-0 order-last" v-if="$auth.superuser">
                <label class="form-check form-switch mb-0">
                  <input class="form-check-input" type="checkbox" v-model="$auth.demoActive" checked="" />
                  <span class="form-check-label">Demo Mode</span>
                </label>
                <a class="nav-link" href="#" v-b-modal.admin-settings-modal>
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-settings" width="24"
                    height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" fill="none"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path
                      d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z">
                    </path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white border-bottom" v-else-if="directoryChrome && site">
      <div class="container">
        <div class="row">
          <div class="col d-flex justify-content-between align-items-center">
            <a :href="`https://${site.directoryurl}/`" target="_blank"><img
                :src="`https://cdn.mediabrains.com/directorylogos/${site.projectname}_pubhome.gif`"
                class="py-1 mw-100 site-logo" /></a>

            <p class="text-end p-0 m-0 ms-auto lh-sm">
              <strong>{{ site.sitename }}</strong>
              <br />
              <span class="text-muted">powered by MediaBrains</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="container" v-if="$auth.isAuthenticated && $auth.featuredPending">
      <div class="row">
        <div class="col-md-12 mt-3">
          <div class="alert alert-warning">
            <strong>Your upgrade is being fulfilled!</strong> Our team will
            reach out to you to finalize your new profile's expert setup. In the
            meantime, you may notice some parts of the MAC not reflecting your
            upgrade. Once our team fulfills your profile, you will have full
            access to the features your new plan offers.
          </div>
        </div>
      </div>
    </div>

    <router-view />

    <settings-modal></settings-modal>

    <footer v-if="chrome" class="footer footer-transparent d-print-none">
      <div class="container">
        <div class="row text-center align-items-center flex-row-reverse">
          <div class="col-lg-auto ms-lg-auto">
            <ul class="list-inline list-inline-dots mb-0">
              <li class="list-inline-item">
                <a href="https://www.mediabrains.com/privacy.htm" class="link-secondary" target="_blank">
                  Privacy Policy
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://www.mediabrains.com/termsofuse.htm" target="_blank" class="link-secondary"
                  rel="noopener">
                  Terms of Use
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-auto mt-3 mt-lg-0">
            <ul class="list-inline list-inline-dots mb-0">
              <li class="list-inline-item">
                Copyright © {{ date }}
                <a href="https://www.mediabrains.com/" target="_blank" class="link-secondary">
                  MediaBrains Inc.
                </a>
                All rights reserved.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<style lang="scss">
.navbar-dark {
  background: #2f8dde !important;
}

.logo {
  height: 36px;
}

.site-logo {
  height: 64px;
}

.mediabrains-1 {
  fill: white;
}
</style>

<script>
import SettingsModal from "../components/Admin/Settings/SettingsModal.vue";
import ActiveCompany from "../components/App/ActiveCompany.vue";
import { Dropdown } from "../components/Tabler/Dropdown";
import SiteService from "../services/SiteService";

export default {
  components: { Dropdown, ActiveCompany, SettingsModal },
  name: "layouts.App",
  data: () => {
    return {
      site: null,
      loaded: false,
      legacy: {
        baseUrl: process.env.VUE_APP_MEDIABRAINS_URL,
        map: {
          reviews: "mac_reviewinvite.aspx",
          leads: "mac_leads.aspx",
          performance_report: "mac_reports.aspx",
          ad_report: "mac_reports_graphical.aspx?sdate=&edate=&ddid=0",
          products: "mac_product.aspx",
          white_papers: "mac_whitepaper.aspx",
          press_releases: "mac_pressrelease.aspx",
          profile: "mac_profile.aspx",
          settings: "mac_account.aspx",
          routes: [],
        },
      },
      date: new Date().getFullYear(),
    };
  },
  computed: {
    userLetters() {
      let firstNameLetter = this.$auth.user.contact.firstName.substring(0, 1);
      let lastNameLetter = this.$auth.user.contact.lastName.substring(0, 1);
      return `${firstNameLetter}${lastNameLetter}`;
    },
    chrome() {
      if (
        this.$route.query.chrome === "off" ||
        this.$route.query.chrome === "directory"
      ) {
        return false;
      }
      return true;
    },
    directoryChrome() {
      if (this.$route.query.chrome === "directory" && this.$route.query.site) {
        return true;
      }
      return false;
    },
  },
  watch: {
    "$route.query": {
      async handler() {
        if (this.$route.query.site) {
          this.site = await SiteService.getSite(this.$route.query.site);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async logout() {
      await this.$auth.logout();
      this.$router.push("/login");
    },
    legacyRoute(component) {
      return this.legacy.map[component];
    },
  },
  async mounted() {
    this.$auth.$watch(
      "user",
      (user) => {
        if (user) {
          this.$gtag.config({
            user_id: this.$auth.user.user.userId,
          });
        }
      },
      {
        immediate: true,
      }
    );

    this.loaded = true;
  },
};
</script>
